import Link from "next/link";
import SectionHeader from "@/components/ui/section-header";
import UseCasesGrid from "@/components/sections/shared/use-cases-grid";
import { ROUTES } from "@/lib/constants";
import { MOBILE_USE_CASES } from "./data";

export default function MobileUseCases() {
  return (
    <section
      id="mobile-use-cases"
      className="py-section border-border border-b"
      aria-labelledby="mobile-use-cases-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 max-w-2xl">
          <SectionHeader
            eyebrow="Use Cases"
            id="mobile-use-cases-heading"
            heading="What You Can Do With Mobile Proxies"
            body="Four workflows where a mobile network origin matters. For high-volume scraping, price monitoring, or AI data collection, residential proxies are usually the better value."
          />
        </div>

        <UseCasesGrid items={MOBILE_USE_CASES} />

        <p className="text-muted-foreground mt-8 text-sm leading-relaxed">
          Looking for a different workflow?{" "}
          <Link
            href={ROUTES.useCases}
            className="text-foreground decoration-foreground/30 hover:decoration-foreground underline underline-offset-4"
          >
            See all Proxidize use cases
          </Link>
          .
        </p>
      </div>
    </section>
  );
}
